<template>
  <div class="homepage">
    <headerComponent :showNormal="false"></headerComponent>
    <div class="home">
      <!-- <img src="../assets/image/111.png" class="bg" alt=""> -->
      <div class="home_nr">
        <div class="home_nr_1">尼尔森IQ社会化媒体研究</div>
        <div class="home_nr_2">NIELSENIQ SOCIAL INTELLIGENCE(NSI)</div>
        <div class="home_nr_3">
          <div class="home_nr_3_1">
            尼尔森IQ着眼于全球，致力于提供全球一体化基于互联网大数据的分析及洞察服务
          </div>
          <div class="home_nr_3_2">为众多客户提供覆盖200多个国家及地区的社媒洞察服务</div>
          <div class="home_nr_3_3">
            结合全球化视野的本土专项团队使解决方案更全面、更精准、更丰富、更灵活
          </div>
        </div>
        <div class="home_nr_4">
          <div class="home_nr_4_1">服务类型：</div>
          <div class="home_nr_4_2">
            标准化BI系统、定制化系统搭建、行业分析、市场分析、社媒营销活动监测、竞品扫描、产品洞察、消费者需求分析、行业知识图谱
          </div>
        </div>
        <div class="home_nr_5">
          <div class="home_nr_5_1">行业经验：</div>
          <div class="home_nr_5_2">
            美妆护肤、食品快餐、快消、3C数码、汽车、酒店旅游、运动服饰、家电、卫浴、互联网、金融服务、
            娱乐
          </div>
        </div>
      </div>
      <div class="home_nav">
        <ul class="list_contain">
          <li class="list" @click="bind(0)" :class="tab == 0 ? 'ccc' : ''">
            <span>社媒指数</span> 
          </li>
          <li class="list" @click="bind(1)" :class="tab == 1 ? 'ccc' : ''">
            <span>社媒热点</span>
          </li>
          <li class="list" @click="bind(2)" :class="tab == 2 ? 'ccc' : ''">
            <span>舆情预警</span>
          </li>
          <li class="list1" @click="bind(3)" :class="tab == 3 ? 'ccc' : ''">
            <span>品牌监测</span>
            <span class="item1">即将上线 敬请期待</span>
          </li>
          <li class="list1" @click="bind(4)" :class="tab == 4 ? 'ccc' : ''">
            <span>产品监测</span>
             <span class="item1">即将上线 敬请期待</span>
          </li>
          <li class="list1" @click="bind(5)" :class="tab == 5 ? 'ccc' : ''">
            <span>活动监测</span>
            <span class="item1">即将上线 敬请期待</span>
          </li>
          <li class="list list2" @click="bind(6)" :class="tab == 6 ? 'ccc' : ''">
            <span>NEWLAND</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="top">
      <div class="top_logo">
        <div class="top_logo_wz">服务优势</div>
        <!-- <div class="top_logo_border"></div> -->
      </div>
      <div class="top_list">
        <div class="top_1">
          <div class="top_1_2">
            <div class="top_1_2_1">200+</div>
            <div class="top_1_2_2"></div>
            <div class="top_1_2_3">
              更国际的视角解读数据背后的故事，全球化社媒解决方案，服务涵盖超过200个国家和地区
            </div>
          </div>
          <div class="top_1_1">
            <img src="../assets/image/222.png" />
          </div>
        </div>
        <div class="top_2">
          <div class="top_2_2">
            <div class="top_2_2_1">90%+</div>
            <div class="top_2_2_2"></div>
            <div class="top_2_2_3">
              分市场/行业/媒体/场景的大数据和规则引擎处理，情感标签准确率90%+，实体类标签准确率95%+
             <!-- 更准确的社媒数据处理结果，分市场、分行业、分媒体、分场景的进行自然语义训练，灵活应对快速发展的社媒语言，多年积累下整体处理准确率高于90% -->
            </div>
          </div>
          <div class="top_2_1">
            <img src="../assets/image/333.png" />
          </div>
        </div>
        <div class="top_3">
          <div class="top_3_2">
            <div class="top_3_2_1">1000+</div>
            <div class="top_3_2_2"></div>
            <div class="top_3_2_3">
              更丰富的业务导向标签体系搭建， 十大维度包含内容类型、情感、产品属性、线上活动、用户特点等超过1000等细分角度备选条件 
            </div>
          </div>
          <div class="top_3_1">
            <img src="../assets/image/444.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="bot">
      <div class="bot_heme">研究报告</div>
      <div class="bot_xx">
        <div class="bot_xx_1">
          <img class="bot_xx_img" src="../assets/image/bg.png" />
          <div class="bot_xxc_1">
            <div class="bot_xx_1_1">Social Discovery 社媒热点月度报告</div>
            <div class="bot_xx_1_2">尼尔森IQ社会媒体化研究</div>

            <div class="bot_xx_1_4">
              <img class="logo" src="../assets/image/bg8.png" />
              <div
              :class="{isActive: btnTab ==0}"
              class="sourceBtn"
              @click="changeSource(1)"
              @mouseover="btnTab =0"
              @mouseleave="btnTab=-1"
              >
              <img :src="btnTab==0?img1:img2" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="bot_xx_1">
          <img class="bot_xx_img" src="../assets/image/middle.jpeg" />
          <div class="bot_xxc_1">
            <div class="bot_xx_1_1">2020年卫浴行业社媒品牌年度报告</div>
            <div class="bot_xx_1_2">尼尔森IQ社会媒体化研究</div>

            <div class="bot_xx_1_4">
              <img class="logo" src="../assets/image/bg8.png" />
              <div
                :class="{isActive: btnTab ==1}"
                class="sourceBtn"
                @click="changeSource(2)"
                @mouseover="btnTab =1"
                @mouseleave="btnTab=-1"
              >
               <img :src="btnTab==1?img1:img2" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="bot_xx_1">
          <img class="bot_xx_img" src="../assets/image/bg2.png" />
          <div class="bot_xxc_1">
            <div class="bot_xx_1_1">95后：洞穿未来消费新势力</div>
            <div class="bot_xx_1_2">尼尔森IQ社会媒体化研究</div>

            <div class="bot_xx_1_4">
              <img class="logo" src="../assets/image/bg8.png" />
              <div
              :class="{isActive: btnTab ==2}"
                class="sourceBtn"
                @click="changeSource(3)"
                @mouseover="btnTab =2"
                @mouseleave="btnTab=-1"
              >
               <img :src="btnTab==2?img1:img2" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bot_xx_2">
          <div class="bot_xxc_2">
            <div class="bot_xx_2_1">年卫浴行业社媒品牌年度报告</div>
            <div class="bot_xx_2_2">尼尔森IQ社会媒体化研究</div>

            <div class="bot_xx_2_4">
              <img style="width: 92.6px; height: 21.3px" src="../assets/image/logo.png" />
              <button
                style="height: 38px; width: 38px; margin-left: 61%; background-color: #00f000"
              >
                →
              </button>
            </div>
          </div>
        </div>
        <div class="bot_xx_3">
          <div class="bot_xxc_3">
            <div class="bot_xx_3_1">95后：洞穿未来消费新势力</div>
            <div class="bot_xx_3_2">尼尔森IQ社会媒体化研究</div>

            <div class="bot_xx_3_4">
              <img style="width: 92.6px; height: 21.3px" src="../assets/image/logo.png" />
              <button
                style="height: 38px; width: 38px; margin-left: 61%; background-color: #ffffff"
              >
                →
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="footer">
      <div class="footer_ts">请完整填写以下内容，我们将尽快与您联系，感谢关注与支持！</div>
      <div class="footer_kj">
           <a-form
            ref="formRef"
            :rules="rules"
            :model="formState"
            >
          <div class="name">
            <div class="name_ming">
              名*<br />
            <a-form-item  hasFeedback style="row-gap: 0px;" name="name"  >
              <a-input allow-clear v-model:value="formState.name" placeholder="名" />
            </a-form-item>
            </div>
            <div class="name_xing">
              姓*<br />
              <a-form-item hasFeedback  style="row-gap: 0px;" name="lastname"  >
                <a-input allow-clear v-model:value="formState.lastname" placeholder="姓" />
              </a-form-item>
            </div>
          </div>
          <div class="company">
            公司*<br />
             <a-form-item hasFeedback  style="row-gap: 0px;" name="companyName"  >
                <a-input allow-clear v-model:value="formState.companyName" placeholder="公司" />
              </a-form-item>
          </div>
          <div class="company">
            部门*<br />
            <a-form-item  hasFeedback style="row-gap: 0px;" name="deptName"  >
              <a-input allow-clear v-model:value="formState.deptName" placeholder="部门" />
            </a-form-item>
          </div>
          <div class="company">
            职务*<br />
            <a-form-item  hasFeedback style="row-gap: 0px;" name="postName"  >
              <a-input allow-clear v-model:value="formState.postName" placeholder="职务" />
            </a-form-item>
          </div>
          <div class="company">
            手机号*<br />
             <a-form-item  hasFeedback style="row-gap: 0px;" name="mobile"  >
              <a-input allow-clear v-model:value="formState.mobile" placeholder="手机号" />
            </a-form-item>
          </div>
          <div class="company">
            邮箱*<br />
            <a-form-item  hasFeedback style="row-gap: 0px;" name="mail"  >
              <a-input allow-clear v-model:value="formState.mail" placeholder="邮箱" />
            </a-form-item>
          </div>
          <div class="company">
            城市*<br />
            <a-form-item  hasFeedback style="row-gap: 0px;" name="city"  >
              <a-input allow-clear v-model:value="formState.city" placeholder="城市" />
            </a-form-item>
          </div>
          <div class="company">
            <div @click="addtj" class="an">发送<ArrowRightOutlined /></div>
          </div>
           </a-form>
      </div>
    </div>
    <div class="dibu">
      <div class="hoverBottom">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a class="ga" href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a class="ga1" href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a></p ></a>
    </div>
    </div>
  </div>
</template>

<script>
import headerComponent from '../components/header'
import { addStatue } from "../utils/api"
import { message } from 'ant-design-vue'
const checkAge = function(rule,val){
  if(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)){
    return Promise.resolve();
  }else{
    return Promise.reject('请填写正确的邮箱');
  }
}
const checkMobile = function(rule,val){
  if(/^[1]([3-9])[0-9]{9}$/.test(val)){
    return Promise.resolve();
  }else{
    return Promise.reject('请填写正确的手机号');
  }
}
import { ArrowRightOutlined} from "@ant-design/icons-vue";
export default {
  data () {
    return {
      tab: null,
      rules :{
        mail: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          { validator: checkAge, message: '请填写正确的邮箱', trigger: 'blur' },
        ],
        name:[
           { required: true, message: '请填写名', trigger: 'blur' },
        ],
        lastname:[
           { required: true, message: '请填写姓', trigger: 'blur' },
        ],
        companyName:[
           { required: true, message: '请填写公司', trigger: 'blur' },
        ],
        deptName:[
           { required: true, message: '请填写部门', trigger: 'blur' },
        ],
        mobile:[
           { required: true, message: '请填写手机号', trigger: 'blur' },
            { validator: checkMobile, message: '请填写正确的手机号', trigger: 'blur' },
        ],
        postName:[
           { required: true, message: '请填写职务', trigger: 'blur' },
        ],
        city:[
           { required: true, message: '请填写城市', trigger: 'blur' },
        ]
      },
      img1: require('../assets/image/bg3.png'),
      img2: require('../assets/image/bg4.png'),
      lastname: '',
      name: '',
      city: '',
      formState:{
        name:'',
        lastname:'',
        city:'',
        companyName:'',
        deptName:'',
        mobile:'',
        postName:'',
        mail:''
      },
      companyName: '',
      deptName: '',
      mobile: '',
      btnTab:-1,
      postName: '',
      mail: '',
      source: '0'
    }
  },

  components: {
    headerComponent,
    ArrowRightOutlined
  },
  mounted () {
    localStorage.removeItem('token')
  },
  methods: {
    changeSource(val){
      this.btnTab = val;
      this.source = val;
      document.querySelector('.footer_kj').scrollIntoView()
    },
    bind (e) {
      if (e == 0) {
        this.tab = e
        location.href = 'https://searchindex.nielseniq.cn/#/'
        // this.$router.push({ path: "/indexLogin" })
      } else if (e == 1) {
        this.tab = e
        location.href = 'https://hotnews.nielseniq.cn/#/'
        // this.$router.push({ path: "/hotLogin" })
      } else if (e == 2) {
        this.tab = e
        location.href = 'https://monitoring.nielseniq.cn/#/'
        // this.$router.push({ path: "/warninglogin" })
      } else if (e == 3) {
        this.tab = e
      } else if (e == 4) {
        this.tab = e
      } else if (e == 5) {
        this.tab = e
      } else if (e == 6) {
        this.tab = e
        location.href = 'https://newland.nielseniq.cn/analytics/Lb.proj/list'
      }
    },
    addtj () {
      let that = this
        this.$refs.formRef.validate().then(()=>{
          addStatue({
            lastname: this.formState.name,
            name: this.formState.lastname,
            city: this.formState.city,
            companyName: this.formState.companyName,
            deptName: this.formState.deptName,
            mobile: this.formState.mobile,
            postName: this.formState.postName,
            mail: this.formState.mail,
            source: this.source,
          }).then(res => {
            if (res.code == 200) {
              message.info('提交成功')
            }
          })
        })
      //   let reg = new RegExp("^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$") //正则邮箱表达式
      //   let rgb = new RegExp("^[0](13|15)[0-9]{9}$") //正则手机号表达式
    //  if (this.name == '') {
    //     message.info('名不得为空')
    //     return
    //   }
    //   if (this.lastname == '') {
    //     message.info('姓不得为空')
    //     return
    //   }
    //   if (this.companyName == '') {
    //     message.info('公司不得为空')
    //     return
    //   }
    //   if (this.deptName == '') {
    //     message.info('部门不得为空')
    //     return
    //   }
    //   if (this.mail == '') {
    //     message.info('邮箱不得为空')
    //     return
    //   }
    //   if (this.mail.indexOf('@') == -1) {
    //     message.info('邮箱格式不正确')
    //     return
    //   }
    //   if (this.mobile == '') {
    //     message.info('手机号码不得为空')
    //     return
    //   }
    //   if (!(/^[1]([3-9])[0-9]{9}$/).test(this.mobile)) {
    //     message.info('手机号格式不正确')
    //     return
    //   }
    //   if (this.postName == '') {
    //     message.info('职位不得为空')
    //     return
    //   }
    //   if (this.city == '') {
    //     message.info('城市不得为空')
    //     return
    //   }
      

    }
  }
}

</script>

<style lang="less" scoped>
.homepage{
    font-family: 'NotoSansSC',sans-serif;
    width: 100vw;
    overflow-x: hidden;
 
}
.home {
  min-height: 100vh;
  width: 100%;
  background-image: url(../assets/image/111.png);
  background-size: 100vw 100%;
  background-repeat: no-repeat;
  // min-width: 1200px;
  .home_nr {
    padding-top: 200px;
    padding-left: 151px;
    .home_nr_1 {
      font-size: 40px;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-weight: bold;
    }
    .home_nr_2 {
      color: #fff;
      font-size: 24px;
      padding-top: 21px;
      font-family: 'Aktiv Grotesk';
    }
    .home_nr_3 {
      padding-top: 21px;
      .home_nr_3_1 {
        font-size: 20px;
        color: #F2F2F2;
      }
      .home_nr_3_2 {
        font-size: 20px;
        color: #F2F2F2;
        padding-top: 20px;
      }
      .home_nr_3_3 {
        font-size: 20px;
        color: #F2F2F2;
        padding-top: 20px;
      }
    }
    .home_nr_4 {
      padding-top: 60px;
      width: 36%;
      .home_nr_4_1 {
        font-size: 20px;
        color: #f2f2f2;
        margin-bottom: 6px;
      }
      .home_nr_4_2 {
        font-size: 20px;
        color: #ffffff;
        // font-weight: bold;
      }
    }
    .home_nr_5 {
      padding-top: 14px;
      width: 38%;
      .home_nr_5_1 {
        font-size: 20px;
        color: #f2f2f2;
        margin-bottom: 6px;
      }
      .home_nr_5_2 {
        font-size: 20px;
        color: #ffffff;
        // font-weight: bold;
      }
    }
  }
  .home_nav {
    width: 100%;
    height: 120px;
    background: rgba(0,0,0,.2);
    margin-top: 165px;
    .list_contain {
      display: flex;
      height: 120px;
      align-items: center;
      padding-left: 152px;
      // padding: 36px 152px;
      // width: 1200px;
      margin: 0 auto;
      .list1{
        width: 230px;
        color: #ffffff;
        text-align: center;
        list-style: none;
        cursor: default;
        height: 30px;
        line-height: 30px;
        // width: 15%;
        // width: fit-content;
        border-right: 1px solid #fff;
        line-height: 1;
        position: relative;
        font-size: 24px;
        span{
          // padding-bottom: 30px;
          width: fit-content;
          position: relative;
          display: block;
          text-align: center;
          margin: 0 auto;
          color: #7C7C7C;
          &.item1{
            color: #7C7C7C;
            font-size: 16px;
            height: 20px;
            line-height: 20px;
            margin-top: 5px;
            position: absolute;
            top: 25px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      .list {
        // flex: 1;
        // padding:0 66px;
        width: 230px;
        height: 30px;
        line-height: 30px;
        color: #ffffff;
        text-align: center;
        list-style: none;
        cursor: pointer;
        // width: 15%;
        // width: fit-content;
        border-right: 1px solid #fff;
        line-height: 1;
        position: relative;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.list2{
          border: 0;
        }
        span{
          // padding-bottom: 30px;
          width: fit-content;
          position: relative;
          &::after{
            content: "";
            display: block;
            height: auto;
            border-bottom: 0!important;
            background-image: linear-gradient(#00f000,#00f000);
           	text-decoration: none;
            padding-bottom: 2px;
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 0 2px;
            transition: background-size .3s;
            position: absolute;
            bottom: -49px;
            left: 0;
            width: 100%;
          }
          &:hover{
            color: #00F000;
            // border-bottom: 1px solid #00F000;
            // background-size: 100% 2px
            &::after{
            	background-size: 100% 2px
            }
          }
        }
        // &.ccc {
        //   color: #00f000;
        //   &:after {
        //     content: '';
        //     position: absolute;
        //     bottom: -20px;
        //     left: 52px;
        //     width: 41%;
        //     height: 2px;
        //     transform: scaleX(1);
        //     background-color: #00f000;
        //   }
        // }
      }
      // .list2 {
      //   color: #ffffff;
      //   text-align: center;
      //   list-style: none;
      //   cursor: pointer;
      //   font-size: 24px;
      //   width: 230px;
      //   line-height: 1;
      //   margin-bottom: 30px;
      //   position: relative;
      //   span{
      //     padding-bottom: 30px;
      //     &:hover {
      //       color: #00F000;
      //       border-bottom: 1px solid #00F000;
      //     }
      //   }
      //   // &.ccc {
      //   //   color: #00f000;
      //   //   &:after {
      //   //     content: '';
      //   //     position: absolute;
      //   //     bottom: -20px;
      //   //     left: 45px;
      //   //     width: 42%;
      //   //     height: 2px;
      //   //     transform: scaleX(1);
      //   //     background-color: #00f000;
      //   //   }
      //   // }
      // }
    }
  }
}
.top {
  width: 100%;
  background-color: #000000;
  background-image: url(../assets/image/bg6.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .top_logo {
    width: 84.17%;
    margin: 0 auto;
    border-bottom: 1px solid #000;
    .top_logo_wz {
      color: #ffffff;
      font-size: 40px;
      padding-top: 127px;
      font-weight: bold;
      padding-bottom: 22px;
      border-bottom: 1px solid #fff;
    }
    .top_logo_border {
      // background-color: #fff;
      // height: .01rem;
    }
  }
  .top_list {
    display: flex;
    padding-top: 167px;
    width: 84.17%;
    margin: 0 auto;
    .top_1 {
      // padding-top: 15.84px;
      // padding-left: 12%;
      margin-right: 40px;
       flex: 1;
      .top_1_1 {
        width: 100%;
        img{
          width: 100%;
          // height: 320px;
        }
      }
      .top_1_2 {
        width: 380px;
        .top_1_2_1 {
          font-size: 41px;
          color: #ffffff;
          font-weight: bold;
          font-family: 'Aktiv Grotesk';
        }
        .top_1_2_2 {
          width: 119px;
          height: 2px;
          background: #00f000;
        }
        .top_1_2_3 {
          margin-top: 18px;
          height: 204px;
          font-family: 'NotoSansSC';
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .top_2 {
       margin-right: 40px;
        flex: 1;
      .top_2_1 {
        width: 100%;
        img{
          width: 100%;
          // height: 320px;
        }
      }
      .top_2_2 {
        width: 400px;
         img{
          width: 100%;
        }
        .top_2_2_1 {
          font-size: 41px;
          color: #ffffff;
          font-family: 'Aktiv Grotesk';
            font-weight: bold;
        }
        .top_2_2_2 {
          width: 147px;
          height: 2px;
          background: #00f000;
        }
        .top_2_2_3 {
          margin-top: 18px;
            height: 204px;
          font-size: 20px;
          color: #fff;
          font-family: 'NotoSansSC';
        }
      }
    }
    .top_3 {
      flex: 1;
      //  margin-right: 40px;
      .top_3_1 {
        width: 100%;
        img{
          width: 100%;
          // height: 320px;
        }
      }
      .top_3_2 {
        width: 402px;
        .top_3_2_1 {
          font-size: 41px;
          font-family: 'Aktiv Grotesk';
          color: #ffffff;
            font-weight: bold;
        }
        .top_3_2_2 {
          width: 147px;
          height: 2px;
          background: #00f000;
        }
        .top_3_2_3 {
          margin-top: 18px;
           height: 204px;
           line-height: 30px;
          font-size: 20px;
          color: #fff;
        }
      }
    }
  }
}
.bot {
  width: 100%;
  background-color: #000000;
  padding-bottom: 186px;
  background-image: url(../assets/image/bg7.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .bot_heme {
    padding-top: 300px;
    color: #ffffff;
    text-align: center;
    font-size: 40px;
    padding-bottom: 70px;
    font-weight: bold;
  }
  .bot_xx {
    margin-top: 80px;
    display: flex;
    width: 84.17%;
    margin: 0 auto;

    .bot_xx_1 {
      height: 600px;
      // width: 32.2%;
      flex: 1;
      // margin-right: 36px;
      &:nth-of-type(1){
        margin-right: 36px;
      }
      &:nth-of-type(2){
        margin-right: 28px;
      }
      //   background-image: url(../assets/image/555.png);
      background-size: 100% auto;
      // margin: 0 auto;
      position: relative;
      .bot_xx_img {
        width: 100%;
        // height: 600px;
      }
      .bot_xxc_1 {
        background-color: transparent;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #fff;
        .bot_xx_1_1 {
          font-size: 20px;
          padding-left: 20px;
          font-family: 'Aktiv Grotesk';
        }
        .bot_xx_1_2 {
          font-size: 16px;
          padding-left: 20px;
          font-weight: bold;
          padding-top: 18px;
        }
        .bot_xx_1_4 {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 33px;
          padding: 0px 20px;
          padding-bottom: 20px;
          // &.bot_xx_1_41{
          //   padding: 0 32px 20px 20px;
          // }
          .logo{
            height: 28px;
          }
        }
        .sourceBtn{
          width: 44px;
          height: 44px;
          border: 1px solid #fff;
          // background-color: transparent;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none!important;
          transition: all .2s ease-in-out;
          background: linear-gradient(45deg,#00f000 50%,transparent 0);
          background-size: 400% 100%;
          background-position: 100% 100%;
          transition: all .3s ease-out;
          img{
            width: 24px;
          }
          &:hover{
            // background-color: #00F000;
            // border-color: #00F000;
            color: #000!important;
            background-color: #fff!important;
            border-color: #00f000!important;
            background-position: 0 100%;
            outline: none!important
          }
          &.isActive{
            // background-color: #0f0;
            // border-color: #0f0;
          }
        }
      }
    }
    // .bot_xx_2 {
    //   height: 475.2px;
    //   width: 32.2%;
    //   background-image: url(../assets/image/666.png);
    //   background-size: 100% auto;
    //   margin: 0 auto;
    //   .bot_xxc_2 {
    //     margin-top: 86%;
    //     margin-left: 20px;
    //     .bot_xx_2_1 {
    //       font-size: 15.84px;
    //       color: #000000;
    //     }
    //     .bot_xx_2_2 {
    //       font-size: 12.84px;
    //       color: #000000;
    //     }
    //     .bot_xx_2_4 {
    //       display: flex;
    //       margin-top: 30px;
    //     }
    //   }
    // }
    // .bot_xx_3 {
    //   height: 475.2px;
    //   width: 32.2%;
    //   background-image: url(../assets/image/777.png);
    //   background-size: 100% auto;
    //   margin: 0 auto;
    //   .bot_xxc_3 {
    //     margin-top: 86%;
    //     margin-left: 20px;
    //     .bot_xx_3_1 {
    //       font-size: 15.84px;
    //       color: #000000;
    //     }
    //     .bot_xx_3_2 {
    //       font-size: 12.84px;
    //       color: #000000;
    //     }
    //     .bot_xx_3_4 {
    //       display: flex;
    //       margin-top: 30px;
    //     }
    //   }
    // }
  }
}
.footer {
  width: 100%;
  background-color: rgb(242, 242, 242);
  padding-bottom: 35px;
  .footer_ts {
    height: 24px;
    font-size: 24px;
    text-align: center;
    color: #000000;
    line-height: 24px;
    margin: 71px 0 30px 27.4%;
    width: fit-content;
  }
  .footer_kj {
    width: 900px;
    margin: 0 auto;
    font-size: 16px;
    background-color: #ffffff;
    padding-bottom: 22px;
    /deep/.ant-form-item-control-wrapper{
      width: 100%;
    }
    /deep/.ant-input-affix-wrapper{
      border-color: #666;
      box-shadow: none;
      &.ant-input-affix-wrapper-focused{
        border-bottom-color: #00f000;
      }
    } 
    /deep/.has-error .ant-input-affix-wrapper{
      border-color: #E58956;
    } 
    /deep/.ant-form-item-children-icon{
      color:#E58956;
    }
    /deep/.ant-form-explain{
      color: #E58956;
    }
    /deep/.ant-form-item{
      margin-bottom: 0;
      padding-bottom: 0;
    }
    // /deep/.ant-input{
    //   width: 100%;
    //   border: 1px solid #666;
    //   outline: none;
    //   height: 40px;
    //   line-height: 40px;
    //   font-size: 16px;
    // }
    .name {
      display: flex;
      padding: 10px 30px;
      font-size: 16px;
      .name_ming {
        width: 346px;
        margin-right: 20px;
        flex: 1;
      }
      .name_xing{
        flex: 1;
      }
    }
    .company {
      padding: 5px 30px;
      font-size: 16px;
      .an {
        width: 103px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border: 1px solid #333;
        // background: #ffffff;
        background-image: none;
        text-align: center;
        cursor: pointer;
        // color: #fff;
        // background-color: #000;
        text-decoration: none!important;
        transition: all .2s ease-in-out;
        background: linear-gradient(45deg,#00f000 50%,#fff 0);
        background-size: 400% 100%;
        background-position: 100% 100%;
        transition: all .3s ease-out;
        &:hover{
        color: #000!important;
        background-color: #fff!important;
        border-color: #00f000!important;
        background-position: 0 100%;
        outline: none!important
        }
        .anticon{
          margin-left: 5px;
        }
      }
    }
  }
}
.dibu {
  width: 100%;
  height: 121px;
  background-color: #000000;
  display: flex;
  align-items: center;
  .hoverBottom{
      position: relative;
      width:fit-content;
      margin: 0 auto 0 auto;
      display: block;
      text-align:center;
      padding:0px 0 0px 0;
      p>a{
        color: rgb(147, 147, 147);
        position: relative;
        padding-bottom: 5px;
        &::after{
            content: "";
            display: block;
            height: auto;
            border-bottom: 0!important;
            background-image: linear-gradient(#00f000,#00f000);
            text-decoration: none;
            padding-bottom: 2px;
            background-position: 0 100%;
            background-repeat: no-repeat;
            background-size: 0 2px;
            transition: background-size .3s;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        &:hover{
            color: #00F000;
            // border-bottom: 1px solid #00F000;
            // background-size: 100% 2px
            &::after{
                background-size: 100% 2px
            }
        }
      }
     
    }
}
</style>